var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6165 12.5792L8.82821 4.57535C8.45602 3.95145 7.54433 3.95145 7.16045 4.57535L2.38433 12.5792C2.00043 13.227 2.46824 14.0431 3.21214 14.0431H12.7883C13.5444 14.0431 14.0125 13.2275 13.6165 12.5792ZM7.49645 7.64747C7.49645 7.33528 7.74865 7.07137 8.07255 7.07137C8.38474 7.07137 8.64865 7.32357 8.64865 7.64747V10.0597C8.64865 10.3719 8.39645 10.6358 8.07255 10.6358C7.76036 10.6358 7.49645 10.3836 7.49645 10.0597V7.64747ZM8.06036 12.4231C7.73645 12.4231 7.48426 12.1592 7.48426 11.847C7.48426 11.5231 7.74817 11.2709 8.06036 11.2709C8.38426 11.2709 8.63645 11.5348 8.63645 11.847C8.63645 12.1592 8.38426 12.4231 8.06036 12.4231Z",
    fill: "#9097A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.3e04a78397e69a7f85428e583b347beb.svg";
export { ForwardRef as ReactComponent };